import { createContext, ReactNode, useContext } from "react";

import type { SelectedCountry } from "./types";

type RegionTreeSelectContextData = {
  selectedCountries: SelectedCountry[];
  onUpdate: (selectedCountries: SelectedCountry[]) => void;
};

const RegionTreeSelectContext = createContext<RegionTreeSelectContextData | null>(
  null
);

export interface RegionTreeSelectContextProviderProps
  extends RegionTreeSelectContextData {
  children: ReactNode;
}

export function RegionTreeSelectContextProvider({
  children,
  ...contextValue
}: RegionTreeSelectContextProviderProps) {
  return (
    <RegionTreeSelectContext.Provider value={contextValue}>
      {children}
    </RegionTreeSelectContext.Provider>
  );
}

export function useRegionTreeSelect() {
  const context = useContext(RegionTreeSelectContext);

  if (!context) {
    throw new Error(
      "useRegionTreeSelectContext hook parent should be wrapped by RegionTreeSelectContextProvider"
    );
  }

  return context;
}
